import { render, staticRenderFns } from "./MobileFileBrowserChrome.vue?vue&type=template&id=5bbbb9f6&"
import script from "./MobileFileBrowserChrome.vue?vue&type=script&lang=js&"
export * from "./MobileFileBrowserChrome.vue?vue&type=script&lang=js&"
import style0 from "./MobileFileBrowserChrome.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports